import { createContext, ReactNode, useContext } from 'react';

interface TakeoverConfig {
  suppressOpen: boolean;
}

const TakeoverConfigContext = createContext<TakeoverConfig>({ suppressOpen: false });

export const TakeoverConfigProvider: React.FC<{
  suppressOpen: boolean;
  children: ReactNode;
}> = ({ suppressOpen, children }) => (
  <TakeoverConfigContext.Provider value={{ suppressOpen }}>
    {children}
  </TakeoverConfigContext.Provider>
);

export const useTakeoverConfig = () => useContext(TakeoverConfigContext);
